import { memo } from 'react'
import SvgIcon from '@/components/SvgIcon/SvgIcon'
import kefuCode from '@/assets/images/kefuCode.png'
import './HumanService.less'
const HumanService = ({ className }: { className?: string }) => {
  return (
    <div className={`HumanService-container ${className}`}>
      <div className='kefuicon'>
        <SvgIcon href={'icon-wework'} />
      </div>
      <p className='concat'>联系客服</p>
      <p className='desc'>任何使用问题请联系客服处理</p>
      <img className='kefu' src={kefuCode} />
      <p className='online'>客服在线时间</p>
      <p className='time'>周一至周日 09:30 ~ 18:00</p>
    </div>
  )
}

export default memo(HumanService)
